import { Form, Formik } from 'formik';
import {
  Button,
  InfoText,
  Input,
  LoadingSpinner,
  Modal,
} from '@rabbit/elements/shared-components';
import * as Yup from 'yup';
import { useContext, useState } from 'react';
import { CaseflowContext } from 'apps/sage/src/context/CaseflowContext';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { CaseFlowActions_Fatbikes_ExternalRepairer } from '@rabbit/bizproc/core';
import { COVERAGE_OPTIONS_FATBIKES } from '@rabbit/bizproc/react';
import { InformationCircleIcon } from '@heroicons/react/24/solid';

export interface ConfirmRepairCoveredModalProps {}

interface FormValuesShape {
  external_repairer_comment: string;
  //comment_to_customer: string;
}

const validationSchema = Yup.object().shape({
  external_repairer_comment: Yup.string().trim(),
  // comment_to_customer: Yup.string().trim(),
});

export function ConfirmRepairCoveredModal({}: ConfirmRepairCoveredModalProps) {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showInternalComment, setShowInternalComment] = useState(false);

  const initialValues = {
    external_repairer_comment: '',
    //comment_to_customer: '',
  };

  const {
    alterCaseFacts,
    alterCasePublicEmail,
    executeAction,
    moveSpotlight,
    setShowModal,
    operatingPersona,
  } = useContext(CaseflowContext) || {};

  if (
    !setShowModal ||
    !executeAction ||
    !alterCaseFacts ||
    !alterCasePublicEmail ||
    !moveSpotlight ||
    !operatingPersona
  )
    return <LoadingSpinner size={'xs'} />;

  const onSubmit = async (values: FormValuesShape) => {
    const { external_repairer_comment } = values;

    setIsSubmitting(true);

    executeAction(CaseFlowActions_Fatbikes_ExternalRepairer.RepairCovered);

    const factsToAlter = {
      ...(external_repairer_comment && {
        external_repairer_comment: {
          comment: external_repairer_comment,
          author: operatingPersona,
        },
      }),
      final_assessment: 'Covered',
    };

    if (Object.keys(factsToAlter).length > 0) {
      await alterCaseFacts(factsToAlter);
    }

    setShowModal(false);
    toast.success(t('general.claimUpdatedSuccessfully'));
  };

  return (
    <Modal
      settings={{
        title: t('message.ConfirmRepairCoveredByWarranty'),
        headerBackground: true,
        handleClose: () => setShowModal(false),
      }}
      kind="generic"
      isLoading={isSubmitting}
      className="max-h-[768px] w-full max-w-[1024px] overflow-y-auto"
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ errors, values }) => (
          <Form className="mt-5 flex flex-col gap-3 px-4">
            <InfoText containerStyles="mb-2 flex gap-1 text-gray-500">
              {t('message.mark_as_covered') + t('message.additional_comments')}
            </InfoText>
            {/* <div className="mt-4">
              <Input
                type="rich-text"
                name="comment_to_customer"
                label="Comment to customer"
                settings={{
                  id: 'comment_to_customer',
                  placeholder: 'Comment to customer',
                }}
              />
            </div> */}
            {!showInternalComment && (
              <div className="mt-4">
                <Button
                  kind="outline"
                  type="button"
                  className="w-full"
                  onClick={() => setShowInternalComment(true)}
                >
                  {t('general.addComment')}
                </Button>
              </div>
            )}
            {showInternalComment && (
              <div>
                <Input
                  type="rich-text"
                  label={t('general.comment')}
                  name="external_repairer_comment"
                  settings={{
                    id: 'external_repairer_comment',
                    placeholder: '',
                    allowSpecialCharacter: true,
                  }}
                />
              </div>
            )}
            <div className="mt-8 flex gap-8">
              <Button kind="primary" type="submit" loading={isSubmitting}>
                {t('general.confirm')}
              </Button>
              <Button kind="outline_red" onClick={() => setShowModal(false)}>
                {t('general.cancel')}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default ConfirmRepairCoveredModal;
